import { Component, ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfigService } from '../../services/config.service';
import { RestApiService } from '../../services/restapi.service';
import { UserService } from '../../services/user.service';
import {  ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { FindEnrollerComponent } from '../findenroller/findenroller.component';
import { UserServiceModal } from 'src/app/modals/userservice.modal';
import { CompanyService } from '../../services/company.service';
import { JoiningdialogComponent } from '../../joiningdialog/joiningdialog.component';
import { DefaultCountry } from 'src/app/constant';

@Component({
  selector: 'app-market-selector',
  templateUrl: './market-selector.component.html',
  styleUrls: ['./market-selector.component.scss']
})
export class MarketSelectorComponent implements OnInit {
  selectedCountry: any = {
    CountryCode: 'US',
    CountryName: 'United States'
  };
  selectedUserType: any = {};
  public allowedCountries: any = [];
  customerTypes: any = {};
  userService: UserServiceModal;
  StatesResponse: [];
  StateNameToggel: boolean = false;
  constructor(
    public dialog: MatDialog,
    public configService: ConfigService,
    public user: UserService,
    public apiService: RestApiService,
    private route: ActivatedRoute,
    public companyService: CompanyService,
    public router: Router
  ) {
    this.userService = user.userServiceModal;
    this.customerTypes = configService.commonSettings.CustomerTypes;
    this.apiService.getActiveCountries().subscribe(data => {
      this.allowedCountries = data?.Data ? data?.Data : data;
      
      // If no countries returned from API, use fallback data
      if (!this.allowedCountries || this.allowedCountries.length === 0) {
        this.allowedCountries = [
          { CountryCode: 'US', CountryName: 'United States' },
          { CountryCode: 'CA', CountryName: 'Canada' },
          { CountryCode: 'GB', CountryName: 'United Kingdom' },
          { CountryCode: 'AU', CountryName: 'Australia' }
        ];
      }
      
      if(this.allowedCountries?.length > 0){
        this.allowedCountries = this.allowedCountries.filter(ac => ac.CountryCode?.toLowerCase() !== "jp");
      }
      const selectedCountry = sessionStorage.getItem('selectedCountry') === 'undefined' ? null : sessionStorage.getItem('selectedCountry');
      const selectedCustomerTypeID = sessionStorage.getItem('selectedCustomerTypeID') === 'undefined' ? null : sessionStorage.getItem('selectedCustomerTypeID');
      
      this.selectedUserType = _.find(this.configService.commonSettings.CustomerTypes, (customerType) => {
        return (customerType.ID === (parseInt(this.route.snapshot.queryParams.type, 10) || parseInt(selectedCustomerTypeID, 10) || 2));
      });
      
      this.selectedCountry = _.find(this.allowedCountries, (item) => {
        return (item.CountryCode.toLowerCase() === (this.route.snapshot.queryParams.countrycode?.toLowerCase() || selectedCountry?.toLowerCase() || 'us'));
      });
      
      // If no country found, use the first one
      if (!this.selectedCountry && this.allowedCountries.length > 0) {
        this.selectedCountry = this.allowedCountries[0];
      }
    }, (error) => {
      console.error('Error loading countries:', error);
      // Use fallback data on error
      this.allowedCountries = [
        { CountryCode: 'US', CountryName: 'United States' },
        { CountryCode: 'CA', CountryName: 'Canada' },
        { CountryCode: 'GB', CountryName: 'United Kingdom' },
        { CountryCode: 'AU', CountryName: 'Australia' }
      ];
      this.selectedCountry = this.allowedCountries[0];
    });
  }

  ngOnInit(): void {
    let queryCategory;
    if (this.route.snapshot.queryParams.catId) {
      queryCategory = parseInt(this.route.snapshot.queryParams.catId, 10);
    } else if (this.route.snapshot.queryParams.category) {
      queryCategory = parseInt(this.route.snapshot.queryParams.category, 10);
    }
  }

  changeAffiliate() {
    this.dialog.open(JoiningdialogComponent, {
      disableClose: true,
      panelClass: 'joining-dialog',
      autoFocus:false
    });
  }

  continue() {
    if (this.selectedCountry?.CountryCode) {
      this.userService.customerTypeID = this.selectedUserType.ID;
      this.dialog.closeAll();
      sessionStorage.setItem('IsMarketCountrySelected', 'true');
      sessionStorage.setItem('selectedCountry', this.selectedCountry.CountryCode || this.configService.commonData.selectedCountry);
      sessionStorage.setItem('selectedLanguageCode', this.configService.commonData.selectedLanguage || this.selectedCountry.CountryLanguages?.[0]?.LanguageCode || 'en');
      sessionStorage.setItem('selectedCustomerTypeID', this.selectedUserType.ID);
      this.getStates();
      this.router.navigate(['/shop']).then(() => {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      });
      // window.location.reload();
    } else {
      console.error('No country selected or country code missing');
    }
  }
  closeDialog() {
    this.dialog.closeAll();
  }

  selectCustomerType(ID): void {
    if (ID) {
      this.selectedUserType = _.find(this.configService.commonSettings.CustomerTypes, (customerType) => {
        return (customerType.ID === parseInt(ID, 10));
      });
    }
  }

  changeLang(code): void {
    if (code) {
      this.selectedCountry = _.find(this.allowedCountries, (country) => {
        return country.CountryCode.trim().toLowerCase() === code.trim().toLowerCase();
      });
    }
  }
  
  getStates() {
    this.apiService.getStates(this.selectedCountry?.CountryCode || DefaultCountry).subscribe((result) => {
      sessionStorage.setItem(DefaultCountry + 'State', JSON.stringify(result.Data));
      if (result.Data && result.Data.length > 0) {
        this.StatesResponse = result.Data;         
        if (this.userService.selectedCountry == DefaultCountry || this.userService.selectedCountry == 'us') {
          // if(this.enrollmentForm?.ApplicantAddress){
          //   this.enrollmentForm.ApplicantAddress.Region = "UT"
          // }
          if(this.userService?.shippingAddress){
            this.userService.shippingAddress.Region = 'UT';
          }
          result.Data.forEach((x => {
            if (x.StateCode == "UT") {
              this.userService.mailingAddress.StateName =
                this.userService.mailingAddress.StateName || result.Data[0].StateName;
            }
          }));
        } else {
          if(this.userService?.shippingAddress){
            this.userService.shippingAddress.Region = result.Data[0].StateCode;
          }
          this.userService.mailingAddress.StateName =
          this.userService.mailingAddress?.StateName || result.Data[0].StateName;
        }
        if (!this.StateNameToggel) {
          this.StateNameToggel = true;
        }
      }
    },
      (error) => {
      }, () => {

      });
  }
}
